import AndroidLogo from '../assets/Technologies-logos/Android.svg';
import AndroidStudioLogo from '../assets/Technologies-logos/Android Studio.svg';
import AngularJSLogo from '../assets/Technologies-logos/AngularJS.svg';
import AWSLogo from '../assets/Technologies-logos/AWS.svg';
import AzureLogo from '../assets/Technologies-logos/Azure.svg';
import BootstrapLogo from '../assets/Technologies-logos/Bootstrap.svg';
import BrowserStackLogo from '../assets/Technologies-logos/BrowserStack.svg';
import CloudflareLogo from '../assets/Technologies-logos/Cloudflare.svg';
import CSS3Logo from '../assets/Technologies-logos/CSS3.svg';
import CypressLogo from '../assets/Technologies-logos/Cypress.svg';
import DockerLogo from '../assets/Technologies-logos/Docker.svg';
import ExpressLogo from '../assets/Technologies-logos/Express.svg';
import FirebaseLogo from '../assets/Technologies-logos/Firebase.svg';
import FlutterLogo from '../assets/Technologies-logos/Flutter.svg';
import GitHubActionsLogo from '../assets/Technologies-logos/GitHub Actions.svg';
import GitHubLogo from '../assets/Technologies-logos/GitHub.svg';
import GoogleCloudLogo from '../assets/Technologies-logos/Google Cloud.svg';
import GrafanaLogo from '../assets/Technologies-logos/Grafana.svg';
import GraphQLLogo from '../assets/Technologies-logos/GraphQL.svg';
import HashiCorpTerraformLogo from '../assets/Technologies-logos/HashiCorp Terraform.svg';
import HelmLogo from '../assets/Technologies-logos/Helm.svg';
import HTML5Logo from '../assets/Technologies-logos/HTML5.svg';
import JUnitLogo from '../assets/Technologies-logos/JUnit.svg';
import KotlinLogo from '../assets/Technologies-logos/Kotlin.svg';
import KubernetesLogo from '../assets/Technologies-logos/Kubernetes.svg';
import MaterialUILogo from '../assets/Technologies-logos/Material UI.svg';
import MongoDBLogo from '../assets/Technologies-logos/MongoDB.svg';
import MySQLLogo from '../assets/Technologies-logos/MySQL.svg';
import NestJSLogo from '../assets/Technologies-logos/Nest.js.svg';
import NextJSLogo from '../assets/Technologies-logos/Next.js.svg';
import NodeJSLogo from '../assets/Technologies-logos/Node.js.svg';
import NodemonLogo from '../assets/Technologies-logos/Nodemon.svg';
import PlaywrightLogo from '../assets/Technologies-logos/Playwrite.svg';
import PostgreSQLLogo from '../assets/Technologies-logos/PostgresSQL.svg';
import PostmanLogo from '../assets/Technologies-logos/Postman.svg';
import PrometheusLogo from '../assets/Technologies-logos/Prometheus.svg';
import ReactBootstrapLogo from '../assets/Technologies-logos/React Bootstrap.svg';
import ReactNativeLogo from '../assets/Technologies-logos/react-native-logo.svg';
import ReactLogo from '../assets/Technologies-logos/React.svg';
import RealmLogo from '../assets/Technologies-logos/Realm.svg';
import RedisLogo from '../assets/Technologies-logos/Redis.svg';
import SeleniumLogo from '../assets/Technologies-logos/Selenium.svg';
import SocketIOLogo from '../assets/Technologies-logos/Socket.io.svg';
import SonarQubeLogo from '../assets/Technologies-logos/SonarQube.svg';
import SplunkLogo from '../assets/Technologies-logos/Splunk.svg';
import SwiftLogo from '../assets/Technologies-logos/Swift.svg';
import TailwindLogo from '../assets/Technologies-logos/Tailwind CSS.svg';
import TypeScriptLogo from '../assets/Technologies-logos/TypeScript.svg';
import VueLogo from '../assets/Technologies-logos/Vue.js.svg';
import WordPressLogo from '../assets/Technologies-logos/WordPress.svg';

export const technologyLogos = {
  Android: { src: AndroidLogo, alt: 'Android' },
  'Android Studio': { src: AndroidStudioLogo, alt: 'Android Studio' },
  AngularJS: { src: AngularJSLogo, alt: 'AngularJS' },
  AWS: { src: AWSLogo, alt: 'AWS' },
  Azure: { src: AzureLogo, alt: 'Azure' },
  Bootstrap: { src: BootstrapLogo, alt: 'Bootstrap' },
  BrowserStack: { src: BrowserStackLogo, alt: 'BrowserStack' },
  Cloudflare: { src: CloudflareLogo, alt: 'Cloudflare' },
  CSS3: { src: CSS3Logo, alt: 'CSS3' },
  Cypress: { src: CypressLogo, alt: 'Cypress' },
  Docker: { src: DockerLogo, alt: 'Docker' },
  Express: { src: ExpressLogo, alt: 'Express.js' },
  Firebase: { src: FirebaseLogo, alt: 'Firebase' },
  Flutter: { src: FlutterLogo, alt: 'Flutter' },
  'GitHub Actions': { src: GitHubActionsLogo, alt: 'GitHub Actions' },
  GitHub: { src: GitHubLogo, alt: 'GitHub' },
  'Google Cloud': { src: GoogleCloudLogo, alt: 'Google Cloud' },
  Grafana: { src: GrafanaLogo, alt: 'Grafana' },
  GraphQL: { src: GraphQLLogo, alt: 'GraphQL' },
  'HashiCorp Terraform': { src: HashiCorpTerraformLogo, alt: 'HashiCorp Terraform' },
  Helm: { src: HelmLogo, alt: 'Helm' },
  HTML5: { src: HTML5Logo, alt: 'HTML5' },
  JUnit: { src: JUnitLogo, alt: 'JUnit' },
  Kotlin: { src: KotlinLogo, alt: 'Kotlin' },
  Kubernetes: { src: KubernetesLogo, alt: 'Kubernetes' },
  'Material UI': { src: MaterialUILogo, alt: 'Material UI' },
  MongoDB: { src: MongoDBLogo, alt: 'MongoDB' },
  MySQL: { src: MySQLLogo, alt: 'MySQL' },
  'Nest.js': { src: NestJSLogo, alt: 'NestJS' },
  'Next.js': { src: NextJSLogo, alt: 'Next.js' },
  'Node.js': { src: NodeJSLogo, alt: 'Node.js' },
  Nodemon: { src: NodemonLogo, alt: 'Nodemon' },
  Playwright: { src: PlaywrightLogo, alt: 'Playwright' },
  PostgreSQL: { src: PostgreSQLLogo, alt: 'PostgreSQL' },
  Postman: { src: PostmanLogo, alt: 'Postman' },
  Prometheus: { src: PrometheusLogo, alt: 'Prometheus' },
  'React Bootstrap': { src: ReactBootstrapLogo, alt: 'React Bootstrap' },
  'React Native': { src: ReactNativeLogo, alt: 'React Native' },
  React: { src: ReactLogo, alt: 'React' },
  Realm: { src: RealmLogo, alt: 'Realm' },
  Redis: { src: RedisLogo, alt: 'Redis' },
  Selenium: { src: SeleniumLogo, alt: 'Selenium' },
  'Socket.io': { src: SocketIOLogo, alt: 'Socket.io' },
  SonarQube: { src: SonarQubeLogo, alt: 'SonarQube' },
  Splunk: { src: SplunkLogo, alt: 'Splunk' },
  Swift: { src: SwiftLogo, alt: 'Swift' },
  'Tailwind CSS': { src: TailwindLogo, alt: 'Tailwind CSS' },
  TypeScript: { src: TypeScriptLogo, alt: 'TypeScript' },
  'Vue.js': { src: VueLogo, alt: 'Vue.js' },
  WordPress: { src: WordPressLogo, alt: 'WordPress' }
};

export function getTechnologyLogos(names) {
  return names
    .map((name) => ({ name, ...technologyLogos[name] }))
    .filter((item) => Boolean(item.src));
}






